import {
  profile,
  loggedIn,
  loggedTaxis,
  axiosInst,
} from "../credentials.js";
import { CookiesApi } from "../utils/helpers";
import { logout } from "../auth.js";
import { get, set } from 'svelte/store';
import {
  loggedFromClient,
  logging_out,
  userDocuments,
  userDetails
} from "../ui-store.js";


export const getUserProjects = async (clientId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "project360/" + clientId + "/projects/get"; 
      const res = await get(axiosInst).get(url, {
        // withCredentials: true
      });
      if (res.status === 200) {
        console.log("getUserProjects successful call", res.data);

        resolve(res.data.data);
      } else {
        alert("getUserProjects :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

export const getProjectArticles = async (clientId, projectId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "project360/" + clientId + "/projects/" + projectId + "/articles"; 
      const res = await get(axiosInst).get(url, {
        // withCredentials: true
      });
      if (res.status === 200) {
        console.log("getProjectArticles successful call", res.data);

        resolve(res.data.data);
      } else {
        alert("getProjectArticles :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};